// extracted by mini-css-extract-plugin
module.exports = {"divider":"HorizontalDivider_divider__jejgX"};